import { useCallback, useState } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

import { Layout } from '../../../CorePackage/MainModule/components/Layout';
import { PassportGroup } from '../../../PassportGroupPackage/PassportGroupModule/PassportGroup';
import { ROUTE_KNM_MASS_CANCELLATION } from '../../../CorePackage/MainModule/routes/routes';
import { PassportMassCancellationModal } from './PassportMassCancellationModal';
import { PassportMassCancellationByKnoModal } from './PassportMassCancellationByKnoModal';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';

export const PassportMassCancellationGroupPage = () => {
  const { id } = useParams<{ id: string }>();
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const [isShowMassCancellationModal, setIsShowMassCancellationModal] = useState(false);
  const [isShowMassCancellationAllowKnoModal, setIsShowMassCancellationAllowKnoModal] = useState(false);
  const [isShowMassCancellationByKnoModal, setIsShowMassCancellationByKnoModal] = useState(false);
  const [selectedPassportIds, setSelectedPassportIds] = useState<number[]>([]);

  const handleShowMassCancellationByKnoModal = useCallback(
    (ids: number[]) => {
      setSelectedPassportIds(ids);
      setIsShowMassCancellationByKnoModal(true);
    },
    [setSelectedPassportIds, setIsShowMassCancellationByKnoModal],
  );

  return (
    <Layout withFooter>
      <>
        <PassportGroup
          backUrl={ROUTE_KNM_MASS_CANCELLATION}
          onMassCancellationApply={() => setIsShowMassCancellationModal(true)}
          onMassCancellationOfKnoApply={() => setIsShowMassCancellationAllowKnoModal(true)}
          onMassCancellationByKnoApply={handleShowMassCancellationByKnoModal}
          isShowCheckbox={isSupervisor}
        />
        {isShowMassCancellationModal && (
          <PassportMassCancellationModal
            groupId={Number.parseInt(id, 10)}
            onClose={() => setIsShowMassCancellationModal(false)}
          />
        )}
        {isShowMassCancellationAllowKnoModal && (
          <PassportMassCancellationModal
            groupId={Number.parseInt(id, 10)}
            onClose={() => setIsShowMassCancellationAllowKnoModal(false)}
            allowKno
          />
        )}
        {isShowMassCancellationByKnoModal && (
          <PassportMassCancellationByKnoModal
            onClose={() => setIsShowMassCancellationByKnoModal(false)}
            passportIds={selectedPassportIds}
          />
        )}
      </>
    </Layout>
  );
};
